import { connect } from 'react-redux';
import { push, goBack, history } from 'connected-react-router';
import VisitActualEdit from './../../../components/VisitActuals/Edit/VisitActualEdit';
// import { getTableSearchResults } from '../../../actions/uiElements/tables';
// import { visitActualsTable } from '../../../settings/constants/endpoints/tableEndpoints';
import { getVisitActual, updateVisitActual, dismissErrors } from '../../../actions/entities/visitActuals';
import { updateVisitTime, addActivityTime } from '../../../actions/areas/visitActuals';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
// import { visitActualsTableConfig } from '../../../components/VisitActuals/List/VisitActualsList';

const mapStateToProps = ({
  areas: { visitActuals: visitActualsArea },
  global: { auth },
  entities: { visitActuals },
  // uiElements,
}) => ({
  isAllocator:
    checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canAllocateWork) ||
    checkFeatureAccess(auth.featureAccessList, globals.applicationFeatureAccesses.canTrigerSync),
  isFetching: visitActuals.previewed.isFetching,
  visitActual: visitActuals.previewed.visitActual,
  patient: visitActuals.previewed.patient,
  failureMessage: visitActuals.previewed.failureMessage,
  visitDuration: visitActualsArea.visit.duration,
  activityTime: visitActualsArea.visit.activityTime,
  enableIntegrationMode: checkFeatureAccess(
    auth.featureAccessList,
    globals.applicationFeatureAccesses.enableIntegrationMode,
  ),
  externalProviderType: auth.externalProviderType,
});

const mapDispatchToProps = dispatch => ({
  getVisitActual: id => dispatch(getVisitActual(id)),
  submitAction: visitActualData => dispatch(updateVisitActual(visitActualData)),
  navigate: url => dispatch(push(url)),
  goBack: () => dispatch(goBack()),
  dismissErrors: () => dispatch(dismissErrors()),
  updateVisitTime: time => dispatch(updateVisitTime(time)),
  addActivityTime: time => dispatch(addActivityTime(time)),
  history,
});

const VisitActualEditContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(VisitActualEdit);

export default VisitActualEditContainer;
